import { useEffect, useState } from 'react';

export default function TopNav() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  const fadeStyle = (delay: number) => ({
    opacity: mounted ? 1 : 0,
    transform: mounted ? 'translateY(0)' : 'translateY(-8px)',
    transition: `opacity 900ms ease ${delay}ms, transform 900ms cubic-bezier(0.22,1,0.36,1) ${delay}ms`,
  });

  return (
    <nav
      className="absolute top-0 left-0 right-0 z-20 flex items-center justify-between px-8 pt-6"
      style={{
        fontFamily:
          'Inter, "Helvetica Neue", Helvetica, Arial, system-ui, sans-serif',
      }}
    >
      {/* Left: brand */}
      <div className="flex items-center gap-3" style={fadeStyle(200)}>
        <span
          className="inline-block"
          style={{
            width: '12px',
            height: '12px',
            backgroundColor: '#7AA8EE',
            borderRadius: '2px',
          }}
        />
        <span
          className="text-white tracking-wider"
          style={{ fontSize: '13px', fontWeight: 600, letterSpacing: '0.12em' }}
        >
          AXIOM
        </span>
        <span
          style={{
            color: 'rgba(255,255,255,0.35)',
            fontSize: '13px',
            fontWeight: 400,
          }}
        >
          / 07
        </span>
      </div>

      {/* Center: chapter marker */}
      <div style={fadeStyle(320)}>
        <span
          className="uppercase"
          style={{
            color: 'rgba(255,255,255,0.55)',
            fontSize: '12px',
            letterSpacing: '0.32em',
            fontWeight: 500,
          }}
        >
          CHAPTER 001 · PRECISION INSTRUMENT
        </span>
      </div>

      {/* Right: live status */}
      <div className="flex items-center gap-2" style={fadeStyle(440)}>
        <span className="relative inline-flex w-2 h-2 items-center justify-center">
          <span
            className="absolute inline-flex w-full h-full rounded-full opacity-60 animate-ping"
            style={{ backgroundColor: '#7AA8EE' }}
          />
          <span
            className="relative inline-block w-2 h-2 rounded-full"
            style={{ backgroundColor: '#7AA8EE' }}
          />
        </span>
        <span
          className="text-white"
          style={{ fontSize: '13px', fontWeight: 500, letterSpacing: '0.06em' }}
        >
          Live · Tokyo
        </span>
      </div>
    </nav>
  );
}